import { all, takeLatest } from "redux-saga/effects";
import { msalInstance } from "../App";
import { appActions } from "../store/app.store";
import { constants } from "../util/constants";

/**
 * ユーザーがログアウトボタンをクリックした
 */
function* onUserClickedLogoutButton() {
  msalInstance.logoutRedirect();
  // localStorage.removeItem(constants.STORAGE_KEY_USER);
  // yield call(persistor.purge);
  // window.location.reload();
}

/**
 * Appサーガ
 */
export function* appSagas() {
  yield all([
    yield takeLatest(
      appActions.USER_CLICKED_LOGOUT_BUTTON,
      onUserClickedLogoutButton
    ),
  ]);
}
